module.exports = __webpack_public_path__ + "img/roadside-assist.bb0a7852.png";